import React from 'react';
import TransactionModule from './transaction.module';
import ProductCmms from 'enums/products-cmms';

const TransactionFDModule = () => {
  return (
    <div>
      <TransactionModule product={ProductCmms.FixedDeposit} />
    </div>
  );
};

export default TransactionFDModule;
